export default {
    tagsDeleteTags_title: "Delete Tags",
    tagsDeleteTags_deleteWarning: "Are you sure you want delete the following tags?",
    tagsDeleteTags_errorSelectTag: "You can not select a tag that will be delete",
    tagsDeleteTags_typeToSearch: "Type to search...",
    tagsDeleteTags_selectTag: "Move the nested tags and entities to",
    tagsDeleteTags_deleted: "Tags deleted successfully",
};